// /* eslint-disable */
// import React, { useEffect } from 'react';
// import { shallowEqual, useDispatch, useSelector } from 'react-redux';
// import { useForm } from "react-hook-form";
// import _ from "lodash/fp";
// import QualificationSubjectList from './QualificationSubjectList';
// import masterLabels from '../labels/master_en.json';
// import commonLabels from '../../../common/labels/common_en.json';
// import { getAllQualificationTypesCombo, getQualificationNamesOfATypeCombo, addQualificationSubject, getQualificationSubject, editQualificationSubject, resetQaulificationSubject, resetQaulificationNamesCombo } from '../actions/masterManagementAction';
// import { SET_QUALIFICATION_SUBJECTS } from '../../../common/constants/ActionTypes';

// const QualificationSubjectForm = ({ addSubject, setAddSubject, setQualificationTypeCode, qualificationNameCode, setQualificationNameCode, setTextToSearch }) => {
//   const dispatch = useDispatch();
//   const { register, handleSubmit, errors } = useForm({
//     mode: "onChange"
//   });

//   const onSubmit = (data, addSubject, setAddSubject) => {
//     let requestBody = {
//       "qualificationNameCode": qualificationNameCode,
//       "subjectName": data.subjectName,
//       "translations": JSON.stringify({ "ma": data.subjectNameMarathi }),
//       "isActive": data.isActive,
//     }

//     if (addSubject.Mode == 'Add') {
//       dispatch(addQualificationSubject(requestBody, setAddSubject, setQualificationNameCode, setTextToSearch));
//     }
//     else if (addSubject.Mode == 'Edit') {
//       requestBody.id = addSubject.id;
//       dispatch(editQualificationSubject(requestBody, setAddSubject, setQualificationNameCode, setTextToSearch));
//     }
//   }

//   useEffect(() => {
//     if (addSubject && addSubject.Mode == 'Add') {
//       dispatch(resetQaulificationNamesCombo());
//       setQualificationNameCode(false);
//     }

//     dispatch(getAllQualificationTypesCombo());
//     addSubject.Mode == "Edit" && addSubject.id > 0 && dispatch(getQualificationSubject(addSubject.id));

//     dispatch({
//       type: SET_QUALIFICATION_SUBJECTS,
//       payload: {},
//     });
//     // eslint-disable-next-line
//   }, [])

//   const onQualificationTypeChange = (e) => {
//     let qualificationSelectedTypeCode = e.target.value;
//     dispatch(getQualificationNamesOfATypeCombo(qualificationSelectedTypeCode));
//   }

//   const { qualificationTypesCombo, qualificationNamesCombo, qualificationSubject } = useSelector((state) => state.masterManagementReducer, shallowEqual);

//   const onCancelButton = () => {
//     setAddSubject({ "Mode": false });
//     setQualificationNameCode(false);
//     setTextToSearch(false);
//     setQualificationTypeCode(false);
//     dispatch(resetQaulificationSubject());
//     dispatch(resetQaulificationNamesCombo());
//   }

//   return addSubject.Mode == false ? (
//     <div>
//       <QualificationSubjectList
//         setAddSubject={setAddSubject}
//       />
//     </div>
//   ) : (
//     <div>
//       <form>
//         <div className="border border-light text-center w-100 p-5" >
//           <div className='form-group'>
//             <div className='row'>
//               <div className='col-md-6'>
//                 <h4><p className='float-left'>{addSubject.Mode == 'Add' ? masterLabels.qualificationSubjectForm.Add_New_Qual_Subject_Label : masterLabels.qualificationSubjectForm.Update_New_Qual_Subject_Label}</p></h4>
//               </div>
//             </div>
//           </div>
//           <br />
//           <div className='form-group'>
//             <div className='row'>
//               <div className='col-md-2'>
//                 <label className="font-weight-bold float-left">{masterLabels.qualificationSubjectForm.Dropdown_Qualification_Type}<span className="redColor">*</span></label>
//                 <select
//                   className='form-control'
//                   name="qualificationType"
//                   onInput={onQualificationTypeChange}
//                   ref={register({ required: true })}
//                   defaultValue={addSubject && addSubject.Mode == 'Edit' && addSubject.qualificationTypeCode}
//                   disabled={addSubject && addSubject.Mode == 'Edit' && true}
//                 >
//                   <option key={0} value="">{commonLabels.COMBO_SELECT}</option>
//                   {qualificationTypesCombo && qualificationTypesCombo.length > 0 && qualificationTypesCombo.filter(element => element.isDeleted == false && (element.isActive === true || addSubject.Mode == 'Edit')).map((element, index) =>
//                     <option key={index} value={element.qualificationtypecode}>{element.qualificationtypename}</option>
//                   )}
//                 </select>
//                 {_.get("qualificationType.type", errors) === "required" && (
//                   <p className="errorText float-left">{commonLabels.MANDATORY_FIELD_MESSAGE}</p>
//                 )}
//               </div>
//               <div className='col-md-3'>
//                 <label className="font-weight-bold float-left">{masterLabels.qualificationSubjectForm.Dropdown_Qualification_Name}<span className="redColor">*</span></label>
//                 <select
//                   className='form-control'
//                   name="qualificationName"
//                   ref={register({ required: true })}
//                   value={qualificationNameCode}
//                   defaultValue={addSubject && addSubject.Mode == 'Edit' && addSubject.qualificationNameCode}
//                   onInput={(event) => setQualificationNameCode(event.target.value)}
//                   disabled={addSubject && addSubject.Mode == 'Edit' && true}
//                 >
//                   <option key={0} value="">{commonLabels.COMBO_SELECT}</option>
//                   {qualificationNamesCombo && qualificationNamesCombo.length > 0 && qualificationNamesCombo.filter(element => element.isDeleted == false && (element.isActive === true || addSubject.Mode == 'Edit')).map((element, index) =>
//                     <option key={index} value={element.qualificationNameCode}>{element.qualificationName}</option>
//                   )}
//                 </select>
//                 {_.get("qualificationName.type", errors) === "required" && (
//                   <p className="errorText float-left">{commonLabels.MANDATORY_FIELD_MESSAGE}</p>
//                 )}
//               </div>
//               <div className='col-md-3'>
//                 <label className='font-weight-bold float-left' >{masterLabels.qualificationSubjectForm.Sub_Name_Field_Label}<span className="redColor">*</span></label>
//                 <input
//                   type="text"
//                   className="form-control input-sm"
//                   name="subjectName"
//                   placeholder={masterLabels.qualificationSubjectForm.Sub_Name_Field_Label}
//                   ref={register({ required: true, maxLength: 300 })}
//                   defaultValue={qualificationSubject && qualificationSubject.subjectName}
//                 />
//                 {_.get("subjectName.type", errors) === "required" && (
//                   <p className="errorText float-left">{commonLabels.MANDATORY_FIELD_MESSAGE}</p>
//                 )}
//                 {_.get("subjectName.type", errors) === "maxLength" && (
//                   <p className="errorText float-left">{commonLabels.MAX_CHAR_VALUE_300}</p>
//                 )}
//               </div>
//               <div className='form-group col-md-2 mt-4'>
//                 <div className="form-check d-flex align-items-center gap-5">
//                   <label className='form-check-label font-weight-bold' htmlFor="isActiveCheckbox">
//                     {masterLabels.qualificationSubjectForm.Subject_Active_Field_Label}?
//                   </label>
//                   <input
//                     className='form-check-input'
//                     type="checkbox"
//                     name="isActive"
//                     value={true}
//                     defaultChecked={qualificationSubject && qualificationSubject.isActive}
//                     ref={register({})}
//                   />
//                 </div>
//               </div>

//             </div>
//             <div className="row mt-5">
//               <div className="col-md-10 d-flex justify-content-end">
//                 <button type="button" className="btn btn-secondary " onClick={() => onCancelButton()}>
//                   {commonLabels.BUTTONS.CANCEL}
//                 </button>
//                 <button type="submit" className=" btn btn-primary custom_button  ms-2  " onClick={handleSubmit((e) => { onSubmit(e, addSubject, setAddSubject); })}>
//                   {commonLabels.BUTTONS.SAVE}
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </form>
//     </div>
//   )
// }

// export default QualificationSubjectForm;





















/* eslint-disable */
import _ from "lodash/fp";
import { useEffect, useState } from 'react';
import { useForm } from "react-hook-form";
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import { validateFieldsForSpaces } from "../../../common/actions/commonActions";
import { SET_QUALIFICATION_SUBJECTS } from '../../../common/constants/ActionTypes';
import commonLabels from '../../../common/labels/common_en.json';
import { addQualificationSubject, editQualificationSubject, getAllQualificationTypesCombo, getQualificationNamesOfATypeCombo, getQualificationSubject, getQualSubjectTypeListPagination, resetQaulificationNamesCombo, resetQaulificationSubject } from '../actions/masterManagementAction';
import masterLabels from '../labels/master_en.json';
import QualificationSubjectList from './QualificationSubjectList';

const QualificationSubjectForm = ({ addSubject, setAddSubject, setQualificationTypeCode, qualificationNameCode, setQualificationNameCode, setTextToSearch,rowPerPage,qualificationSubjectNames }) => {
  const dispatch = useDispatch();
    const [selectedOption, setSelectedOption] = useState(null);
  const [selectedQualiNameOption, setSelectedQualiNameOption] = useState(null);

  const { register, handleSubmit, errors } = useForm({
    mode: "onChange"
  });

  useEffect(()=>{
         dispatch(getQualSubjectTypeListPagination(pageNo,rowPerPage))

  },[])

  // const { qualificationSubjectNames } = useSelector((state) => state.masterManagementReducer, shallowEqual);

  // let pageNo = Math.round(totalCount/rowPerPage) 
  let pageNo = Math.floor((qualificationSubjectNames.totalNoOfRecords)/rowPerPage)


  const onSubmit = (data, addSubject, setAddSubject) => {
    let requestBody = {
      "qualificationNameCode": qualificationNameCode,
      "subjectName": data.subjectName,
      "translations": JSON.stringify({ "ma": data.subjectNameMarathi }),
      "isActive": data.isActive,
    }

     const isValid = validateFieldsForSpaces({
       "Qualification name code": qualificationNameCode,
       "Subject Name": data.subjectName,
     });
  
     if (!isValid) return; // Stop form submission or further logic
  
    if (addSubject.Mode == 'Add') {
      dispatch(addQualificationSubject(requestBody, setAddSubject, setQualificationNameCode, setTextToSearch));
    }
    else if (addSubject.Mode == 'Edit') {
      requestBody.id = addSubject.id;
      dispatch(editQualificationSubject(requestBody, setAddSubject, setQualificationNameCode, setTextToSearch));
    }    

    dispatch(getQualSubjectTypeListPagination(pageNo,rowPerPage))
  }

  useEffect(() => {
    if (addSubject && addSubject.Mode == 'Add') {
      dispatch(resetQaulificationNamesCombo());
      setQualificationNameCode(false);
    }

    dispatch(getAllQualificationTypesCombo());
    addSubject.Mode == "Edit" && addSubject.id > 0 && dispatch(getQualificationSubject(addSubject.id));

    dispatch({
      type: SET_QUALIFICATION_SUBJECTS,
      payload: {},
    });
    // eslint-disable-next-line
  }, [])

  const onQualificationTypeChange = (e) => {
    let qualificationSelectedTypeCode = e.target.value;
    dispatch(getQualificationNamesOfATypeCombo(qualificationSelectedTypeCode));
  }

  const { qualificationTypesCombo, qualificationNamesCombo, qualificationSubject } = useSelector((state) => state.masterManagementReducer, shallowEqual);

  const onCancelButton = () => {
    setAddSubject({ "Mode": false });
    setQualificationNameCode(false);
    setTextToSearch(false);
    setQualificationTypeCode(false);
    dispatch(resetQaulificationSubject());
    dispatch(resetQaulificationNamesCombo());
  }



   // Create options for react-select
  const options = (qualificationTypesCombo || [])
    .filter(
      (element) =>
        element.isDeleted === false &&
        (element.isActive === true || addSubject.Mode === 'Edit')
    )
    .map((element) => ({
      value: element.qualificationtypecode,
      label: element.qualificationtypename,
    }));

  // Set default value in Edit mode
  useEffect(() => {
    if (addSubject.Mode === 'Edit') {
      const matched = options.find(
        (opt) => opt.value === addSubject.qualificationTypeCode
      );
      setSelectedOption(matched || null);
    }
  }, [addSubject, options]);

  // Handle selection change
  const handleChange = (selected) => {
    setSelectedOption(selected);

    // Manually call the original onInput handler
    onQualificationTypeChange({
      target: {
        name: 'qualificationType',
        value: selected?.value || '',
      },
    });
  };


 const qualificationNameOptions = Array.isArray(qualificationNamesCombo)
  ? qualificationNamesCombo
      .filter(
        (element) =>
          !element.isDeleted &&
          (element.isActive || addSubject?.Mode === 'Edit')
      )
      .map((element) => ({
        value: element.qualificationNameCode,
        label: element.qualificationName,
      }))
  : [];

  // Set default in edit mode
  useEffect(() => {
    if (addSubject?.Mode === 'Edit') {
      const match = qualificationNameOptions.find(
        (opt) => opt.value === addSubject.qualificationNameCode
      );
      setSelectedQualiNameOption(match || null);
    }
  }, [addSubject, qualificationNameOptions]);

  const handleChangeQualificationName = (selected) => {
    setSelectedQualiNameOption(selected);
    setQualificationNameCode(selected?.value || '');
  };

  return addSubject.Mode == false ? (
    <div>
      <QualificationSubjectList
        setAddSubject={setAddSubject}
        totalNoOfRecords={pageNo}
      />
    </div>
  ) : (
    <div>
      <form>
        <div className="border border-light text-center w-100 p-5" >
          <div className='form-group'>
            <div className='row'>
              <div className='col-md-6'>
                <h4><p className='float-left'>{addSubject.Mode == 'Add' ? masterLabels.qualificationSubjectForm.Add_New_Qual_Subject_Label : masterLabels.qualificationSubjectForm.Update_New_Qual_Subject_Label}</p></h4>
              </div>
            </div>
          </div>
          <br />
          <div className='form-group'>
            <div className='row'>
              <div className='col-md-2'>
                <label className="font-weight-bold float-left">{masterLabels.qualificationSubjectForm.Dropdown_Qualification_Type}<span className="redColor">*</span></label>
                {/* <select
                  className='form-control'
                  name="qualificationType"
                  onInput={onQualificationTypeChange}
                  ref={register({ required: true })}
                  defaultValue={addSubject && addSubject.Mode == 'Edit' && addSubject.qualificationTypeCode}
                  disabled={addSubject && addSubject.Mode == 'Edit' && true}
                >
                  <option key={0} value="">{commonLabels.COMBO_SELECT}</option>
                  {qualificationTypesCombo && qualificationTypesCombo.length > 0 && qualificationTypesCombo.filter(element => element.isDeleted == false && (element.isActive === true || addSubject.Mode == 'Edit')).map((element, index) =>
                    <option key={index} value={element.qualificationtypecode}>{element.qualificationtypename}</option>
                  )}
                </select> */}
                <br />
     <Select
        name="qualificationType"
        value={selectedOption}
        onChange={handleChange}
        options={options}
        placeholder={commonLabels.COMBO_SELECT}
        isDisabled={addSubject?.Mode === 'Edit'}
        isSearchable
      />

      {/* Hidden input to integrate with react-hook-form */}
      <input
        type="hidden"
        name="qualificationType"
        value={selectedOption?.value || ''}
        ref={register({ required: true })}
      /> 
                {_.get("qualificationType.type", errors) === "required" && (
                  <p className="errorText float-left">{commonLabels.MANDATORY_FIELD_MESSAGE}</p>
                )}
              </div>
              <div className='col-md-3'>
                <label className="font-weight-bold float-left">{masterLabels.qualificationSubjectForm.Dropdown_Qualification_Name}<span className="redColor">*</span></label>
                {/* <select
                  className='form-control'
                  name="qualificationName"
                  ref={register({ required: true })}
                  value={qualificationNameCode}
                  defaultValue={addSubject && addSubject.Mode == 'Edit' && addSubject.qualificationNameCode}
                  onInput={(event) => setQualificationNameCode(event.target.value)}
                  disabled={addSubject && addSubject.Mode == 'Edit' && true}
                >
                  <option key={0} value="">{commonLabels.COMBO_SELECT}</option>
                  {qualificationNamesCombo && qualificationNamesCombo.length > 0 && qualificationNamesCombo.filter(element => element.isDeleted == false && (element.isActive === true || addSubject.Mode == 'Edit')).map((element, index) =>
                    <option key={index} value={element.qualificationNameCode}>{element.qualificationName}</option>
                  )}

                </select> */}

<br />
                 <Select
        name="qualificationName"
        value={selectedQualiNameOption}
        onChange={handleChangeQualificationName}
        options={qualificationNameOptions}
        isSearchable
        isDisabled={addSubject?.Mode === 'Edit'}
        placeholder={commonLabels.COMBO_SELECT}
      />

      {/* Hidden input for react-hook-form registration */}
      <input
        type="hidden"
        name="qualificationName"
        value={selectedQualiNameOption?.value || ''}
        ref={register({ required: true })}
      />
                {_.get("qualificationName.type", errors) === "required" && (
                  <p className="errorText float-left">{commonLabels.MANDATORY_FIELD_MESSAGE}</p>
                )}
              </div>
              <div className='col-md-3'>
                <label className='font-weight-bold float-left' >{masterLabels.qualificationSubjectForm.Sub_Name_Field_Label}<span className="redColor">*</span></label>
                <input
                  type="text"
                  className="form-control input-sm"
                  name="subjectName"
                  placeholder={masterLabels.qualificationSubjectForm.Sub_Name_Field_Label}
                  ref={register({ required: true, maxLength: 300 })}
                  defaultValue={qualificationSubject && qualificationSubject.subjectName}
                />
                {_.get("subjectName.type", errors) === "required" && (
                  <p className="errorText float-left">{commonLabels.MANDATORY_FIELD_MESSAGE}</p>
                )}
                {_.get("subjectName.type", errors) === "maxLength" && (
                  <p className="errorText float-left">{commonLabels.MAX_CHAR_VALUE_300}</p>
                )}
              </div>
              <div className='form-group col-md-2 mt-4'>
                <div className="form-check d-flex align-items-center gap-5">
                  <label className='form-check-label font-weight-bold' htmlFor="isActiveCheckbox">
                    {masterLabels.qualificationSubjectForm.Subject_Active_Field_Label}?
                  </label>
                  <input
                    className='form-check-input'
                    type="checkbox"
                    name="isActive"
                    value={true}
                    defaultChecked={qualificationSubject && qualificationSubject.isActive}
                    ref={register({})}
                  />
                </div>
              </div>

            </div>
            <div className="row mt-5">
              <div className="col-md-10 d-flex justify-content-end">
                <button type="button" className="btn btn-secondary " onClick={() => onCancelButton()}>
                  {commonLabels.BUTTONS.CANCEL}
                </button>
                <button type="submit" className=" btn btn-primary custom_button  ms-2  " onClick={handleSubmit((e) => { onSubmit(e, addSubject, setAddSubject); })}>
                  {commonLabels.BUTTONS.SAVE}
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  )
}

export default QualificationSubjectForm;